'use client';

import { useEffect } from 'react';
import { plural } from '@frameio/i18n';
import { Dialog, Spinner, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/UIBlock';
import styles from './UIBlock.module.css';

TEXT.DEFINE({
  /** Message to show when compositions are rendering */
  renderingComps: (count: number): string =>
    plural(count, {
      one: `Rendering ${count} composition.`,
      other: `Rendering ${count} compositions.`,
    }),
  /** Description to show when compositions are rendering */
  description:
    'Panel is paused during rendering. Monitor or cancel in the Render Queue panel.',
});

export const UIBlock = ({ renderCount }: { renderCount: number }) => {
  useEffect(() => {
    // Disable all key presses while the UI block is active to prevent user from
    // interacting with AE while compositions are rendering
    const handleKeyDown = (event: KeyboardEvent) => {
      event.preventDefault();
      event.stopPropagation();
    };

    window.addEventListener('keydown', handleKeyDown, {
      capture: true,
    });

    return () => {
      window.removeEventListener('keydown', handleKeyDown, {
        capture: true,
      });
    };
  }, []);

  return (
    <Dialog
      aria-label="test"
      className={styles.dialog}
      enableClickOutsideToClose={false}
      isShowing={true}
      size="x-small"
      zIndex={6000}
    >
      <div className={styles.dialogContent}>
        <div className={styles.spinnerContainer}>
          <Spinner
            aria-labelledby="rendering-text"
            delay={0}
            isLoading={true}
            size="medium"
            variant="brandMulti"
          />
        </div>
        <Text
          as="h2"
          color="primary"
          id="rendering-text"
          style={{
            textWrap: 'pretty',
            maxWidth: '100%',
          }}
          variant="header"
        >
          {TEXT.renderingComps(renderCount)}
        </Text>
        <Text
          color="body"
          style={{
            textWrap: 'pretty',
            width: '100%',
          }}
          variant="body"
        >
          {TEXT.description}
        </Text>
      </div>
    </Dialog>
  );
};
